import { useCallback, useEffect, useRef, useState } from 'react';
import { getScrollContainer } from '../utils';
import { SELECTION_COLOR } from '../constants';

export const useScrollToHighlight = ({ viewerControl }: any) => {
  const [scrollToHighlight, setScrollToHighlight] = useState<any>(null);
  const oldMarkToBeUpdatedColorRef = useRef<any>(null);

  const clearScrollToHighlight = useCallback(() => {
    if (scrollToHighlight) {
      try {
        const allMarks = viewerControl.getAllMarks();
        const mark = allMarks.find((x: any) => x.uid === scrollToHighlight.annotation.uid);
        if (mark) {
          mark.fillColor = oldMarkToBeUpdatedColorRef.current;
          oldMarkToBeUpdatedColorRef.current = null;
        }
        setScrollToHighlight(null);
      } catch (error) {
        console.error('Error clearing scroll to highlight:', error);
        setScrollToHighlight(null);
      }
    }
  }, [scrollToHighlight, viewerControl]);

  const scrollToHighlightHandler = (highlight: any) => {
    clearScrollToHighlight();

    try {
      const allMarks = viewerControl.getAllMarks();
      const mark = allMarks.find((x: any) => x.uid === highlight.annotation.uid);

      const scrollToMark = (mark: any) => {
        try {
          // Verify mark is still attached to the document before operating on it
          const currentMarks = viewerControl.getAllMarks();
          const markExists = currentMarks.some((m: any) => m.uid === mark.uid);
          
          if (!markExists) {
            console.warn('Cannot scroll to mark: not found in document', { markId: mark.uid });
            return;
          }
          
          oldMarkToBeUpdatedColorRef.current = mark.fillColor;
          mark.setFillColor(SELECTION_COLOR);
          setScrollToHighlight(highlight);
          viewerControl.scrollToAsync(mark);
        } catch (error) {
          console.error('Error scrolling to mark:', error, { markId: mark?.uid });
        }
      };

      if (mark) {
        scrollToMark(mark);
      } else {
        if (highlight?.annotation?.pageNumber) {
          viewerControl
            .scrollToAsync({
              pageNumber: highlight.annotation.pageNumber,
              x: highlight.annotation?.rectangle?.x || 500,
              y: highlight.annotation?.rectangle?.y || 500,
            })
            .then(() => {
              setTimeout(() => {
                try {
                  const currentMarks = viewerControl.getAllMarks();
                  const mark = currentMarks.find((x: any) => x.uid === highlight.annotation.uid);
                  if (mark) {
                    scrollToMark(mark);
                  }
                } catch (error) {
                  console.error('Error finding mark after scroll:', error);
                }
              }, 250);
            })
            .catch((error: any) => {
              console.error('Error scrolling to position:', error);
            });
        }
      }
    } catch (error) {
      console.error('Error in scrollToHighlightHandler:', error);
    }
  };

  useEffect(() => {
    getScrollContainer(viewerControl)?.addEventListener('mousedown', clearScrollToHighlight);

    return () => {
      getScrollContainer(viewerControl)?.removeEventListener('mousedown', clearScrollToHighlight);
    };
  }, [clearScrollToHighlight, viewerControl]);

  return {
    scrollSelectedHighlight: scrollToHighlight,
    scrollToHighlight: scrollToHighlightHandler,
  };
};
